import React, {
  useEffect,
  useState
} from "react";

import AdminLayout from "./AdminLayout";

const AdminInfrastructure =
  () => {
    const [title, setTitle] =
      useState("");

    const [file, setFile] =
      useState(null);

    const [data, setData] =
      useState([]);

    const fetchData = () => {
      fetch(
        " https://node.ilakshyaerp.in/api/infrastructure-documents"
      )
        .then((res) =>
          res.json()
        )
        .then((res) =>
          setData(
            Array.isArray(res)
              ? res
              : []
          )
        )
        .catch(() =>
          setData([])
        );
    };

    useEffect(
      fetchData,
      []
    );

    const submit =
      async () => {
        if (
          !title ||
          !file
        ) {
          alert(
            "Enter title and choose file ❌"
          );
          return;
        }

        try {
          const fd =
            new FormData();

          fd.append(
            "title",
            title
          );

          fd.append(
            "file",
            file
          );

          const res =
            await fetch(
              " https://node.ilakshyaerp.in/api/infrastructure-documents/add",
              {
                method:
                  "POST",
                body: fd,
              }
            );

          const d =
            await res.json();

          if (
            !res.ok
          ) {
            alert(
              d.message ||
                "Upload failed ❌"
            );
            return;
          }

          alert(
            d.message
          );

          fetchData();

          setTitle("");
          setFile(null);
        } catch {
          alert(
            "Network error ❌"
          );
        }
      };

    const remove =
      async (id) => {
        try {
          const res =
            await fetch(
              ` https://node.ilakshyaerp.in/api/infrastructure-documents/${id}`,
              {
                method:
                  "DELETE",
              }
            );

          const d =
            await res.json();

          alert(
            d.message ||
              "Deleted ✅"
          );

          fetchData();
        } catch {
          alert(
            "Delete failed ❌"
          );
        }
      };

    return (
      <AdminLayout>
        <div className="notice-page">

          <div className="notice-card">
            <h2>
              Upload Infrastructure
            </h2>

            <input
              placeholder="Title"
              value={title}
              onChange={(e) =>
                setTitle(
                  e.target.value
                )
              }
            />

            <input
              type="file"
              onChange={(e) =>
                setFile(
                  e.target
                    .files[0]
                )
              }
            />

            <button
              onClick={
                submit
              }
            >
              Upload
            </button>
          </div>

          <div className="notice-table">
            <table>
              <tbody>
                {data.map(
                  (d) => (
                    <tr
                      key={
                        d.id
                      }
                    >
                      <td>
                        {
                          d.title
                        }
                      </td>

                      <td>
                        <button
                          className="delete-btn"
                          onClick={() =>
                            remove(
                              d.id
                            )
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  )
                )}

                {data.length ===
                  0 && (
                  <tr>
                    <td
                      colSpan="2"
                      style={{
                        textAlign:
                          "center",
                      }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </AdminLayout>
    );
  };

export default AdminInfrastructure;